<template>
    <div>
        <div v-show="modale" id="modale" @click="toggleModale">
            <button class="close"></button>
            <img v-if="data.src" :alt="data.alt" :src="data.src" @click="false" />
        </div>
        <img class="thumbnail"  :alt="data.alt" :src="data.src" @click="toggleModale" />
    </div>
</template>

<script>
export default {
    props: {
        'oma': {type: Object, required: true},
        'channel': {type: Number, required: true},
        'defaut': {type: String, default: '/favicon.webp'},
    },
    data: () => ({
        direct: {},
        replay: {},
        modale: false,
    }),
    created: function () {
        this.direct = this.update()
        this.replay = this.update()
        this.oma.ows.handler(    this.channel, (data) => { this.direct = this.update(data) })
        this.oma.ows.handler('R'+this.channel, (data) => { this.replay = this.update(data) })
    },
    methods: {
        update: function (data = []) {
            if (data.length == 0 || !('N' in data[0]) || data[0].N.trim() == '') {
              return {alt: 'Image par défaut', src: this.defaut}
            } else {
              return {alt: data[0].D, src: this.oma.radioHost + '/soundbase/webpL/' + data[0].N + '.webpL'}
            }
        },
        toggleModale: function () {
            this.modale = !this.modale;
        }
    },
    computed: {
        data: function () {
            return this.oma.player.TYPES.isReplay || this.oma.player.TYPES.isPodcast ? this.replay : this.direct
        },
        showmodale: function () {
            return this.modale && this.data.src;
        },
    }
}
</script>

<style scoped="">
img.thumbnail {
	height: 100px;
}

#modale {
    position: fixed;
    top: 0;
    left: 0;
    width:100%;
    height: 100%;
	z-index: 999;
    background-color:rgba(1,1,1,.6);
}

#modale img {
    height: 100%;
	background-color: #fff;
	margin: auto;
	display: block;
}

button.close {
	background-image: url("@/assets/img/close.svg");
	height: 10em;
	width: 10em;
	border-radius: 5em;
	position: absolute;
	top:0;
	left: 0;
}
</style>
